import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ICON_EYE_FILL, ICON_EYE_SLASH_FILL } from "../../utils/icons";
import { Button, Form, Input, PasswordInput } from "../../styles";
import AuthWrapper from "../../layout/AuthWrapper";
import { useUserContext } from "../../context/user_context";
import { encrypt } from "../../encrypt";
import { useLocalStorage } from "../../utils/useLocalStorage";
import AuthApi from "../../api/authAxios";
import { hook } from "../../assets";

function UserLogin() {

  const [issending, setissending] = useState(false);
  const [userData, setuserData] = useLocalStorage('accountData');
  const [formField, setformField] = useState({});

  const {
    usertoken, btoken, stoken
  } = useUserContext();

  let navigate = useNavigate();


  // Check if User is logged in, if yes go to dashboard
  // if (usertoken && btoken && stoken) {
  //   navigate('/user/dashboard');
  // }
  // Check if User is logged in, if yes go to dashboard

  // Form Fields
  function handleChange(e) {
    setformField((inputs) => ({
      ...inputs,
      [e.target.name]: e.target.value,
    }));
  }
  // Form Fields

  //   Login Function
  //   Login Function
  function submitFn(e) {

    e.preventDefault();
    if ((formField.pword && formField.email)) {

      setissending(true);
      const data = {
        pword: formField.pword,
        mail: formField.email,
      };
      AuthApi.post(`/login`, data)
        .then((res) => {
          console.log(res);

          if (res.success === false) {
            toast.warn(res.message);
            setissending(false);

          } else {

            setissending(false);
            setuserData(encrypt(res.data));
            navigate("/set-profile");
            setTimeout(() => {
              toast.success(res.message);
            }, 10);
          }
        })
        .catch((error) => {
          setissending(false);
        });
    } else {
      setissending(false);
      toast.warn("Empty Fields !!!");
    }
  }
  //   Login Function
  //   Login Function

  // Password Show Function 
  const [eye, seteye] = useState(false);
  // Password Show Function 

  // Route to Reni Trust
  function toForgetPW(e) {
    // e.preventDefault()
    if (window.confirm('You will redirected to your Renitrust Account, Confirm?')) {
      window.open('https://renitrust.com/reset-password', '_blank');
    }
  }
  // Route to Reni Trust

  return (
    <>
      <AuthWrapper
        title='Sign In'
        subTitle='Welcome back, Let’s get you into your RENI account.'
        img={hook}
      >
        <Form onSubmit={(e) => submitFn(e)}>
          <div className="row justify-content-center text-left">
            <div className="col-md-12 ">
              <label className="mb-0"> Email:</label>
              <div className="input-group">
                <Input
                  type="email"
                  name="email"
                  placeholder="example@example.com"
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="col-md-12 password-input">
              <label className="mb-0"> Password:</label>
              <div className="input-group">
                <PasswordInput
                  type={eye ? 'text' : 'password'}
                  name="pword"
                  placeholder="************"
                  onChange={handleChange}
                  required
                />
                <span
                  className={`toggle-eye`}
                  onClick={() => seteye(!eye)}
                >
                  {eye ? ICON_EYE_FILL : ICON_EYE_SLASH_FILL}
                </span>
              </div>
            </div>

            <div className="col-md-12 mx-auto text-center">
              <Button
                pry
                type="submit"
                disabled={issending}
                className="btn m-0 w-100"  >
                {issending ? 'loading...' : "Login"}
              </Button>

              <div className="text-center mt-4">
                <small>
                  Forgot your password ?
                  <span onClick={toForgetPW} className="pry-text pointer"> Reset it here.</span>
                </small>
                <hr className="m-2" />
                <small>
                  Don't have an account ?
                  <Link to="/register" className="pry-text"> Sign Up</Link>
                </small>
              </div>
            </div>
          </div>
        </Form>
      </AuthWrapper>

    </>
  );
}

export default UserLogin;
